import React, { useRef } from "react";
import AppelAction from "../../components/AppelAction";
import SEOHead from "../../components/SEOHead";

// import styles from "./Features.module.sass";
import HeroProspection from "./HeroProspection";
import FonctionnalitesContrat from "./FonctionnalitesContrat";
import AvantagesGestion from "./AvantageGestion";  
import SolutionEmargement from "./SolutionEmargement";
import ExportEmargement from "./ExportEmargement";
import Faq from "./Faq";

const Prospection = () => {
  const scrollToRef = useRef(null);

  const seoData = {
    title: "Prospection & Leads - CRM intégré pour centres de formation | Edutio",
    description: "Optimisez votre prospection avec le CRM Edutio. Gestion des leads, suivi des prospects, automatisation des relances et conversion pour votre centre de formation.",
    keywords: "prospection CFA, gestion leads, CRM formation, suivi prospects, conversion leads, automatisation marketing"
  };

  return (
    <>
      <SEOHead {...seoData} />
      <HeroProspection  scrollToRef={scrollToRef} />
      <AvantagesGestion  className="section-pb" scrollToRef={scrollToRef} />
      <SolutionEmargement />
      <ExportEmargement />
      <FonctionnalitesContrat />
      <Faq />
      <AppelAction className="section" />
    </>
  );
};

export default Prospection;
